import { ReplaceButtonCombinedProps } from './types';

const usePresenter = (props: ReplaceButtonCombinedProps): ReplaceButtonCombinedProps => {
  return props;
};

export default usePresenter;
